/** The seconds the materials animate by, and with them everything that must move in step with
 *  what they draw. A still frame is drawn at zero. */
let sharedClock: (() => number) | null = null;

export function bindSceneClock(clock: (() => number) | null): void {
  sharedClock = clock;
}

export function sceneSeconds(still: boolean, local = performance.now() / 1000): number {
  return still ? 0 : (sharedClock?.() ?? local);
}
